import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import {
  Translation,
  TRANSLOCO_CONFIG,
  TRANSLOCO_LOADER,
  translocoConfig,
  TranslocoLoader,
  TranslocoModule
} from '@ngneat/transloco';
import { zip } from 'rxjs';
import { map } from 'rxjs/operators/map';
import { environment } from '../environments/environment';
import { defaultLocale, LanguageCode } from './translations/language.model';

export const translocoRootConfig = translocoConfig({
  availableLangs: [
    { id: LanguageCode.en, label: 'English' },
    { id: LanguageCode.es, label: 'Español' },
    { id: LanguageCode.fr, label: 'Français' },
    { id: LanguageCode['fr-qc'], label: 'Français (Québec)' },
    { id: LanguageCode['es-sa'], label: 'Español (latinoamericano)' }
  ],
  defaultLang: defaultLocale,
  fallbackLang: defaultLocale,
  reRenderOnLangChange: true,
  prodMode: environment.production
});

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly parentFileLocation = '/assets/i18n';

  private readonly translationFileNameArray = [
    'general',
    'assessment',
    'questionnaire',
    'derfs',
    'pdf',
    'treatment',
    'dashboard',
    'mass-clinic',
    'medical-history',
    'user-dropdown',
    'profile',
    'referral-center',
    'clinic-setup',
    'inbox',
    'signs',
    'impression',
    'intake-forms',
    'day-sheets',
    'patient-portal'
  ];
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    return zip(
      ...this.translationFileNameArray.map(fileName => {
        return this.http.get<Translation>(`${this.parentFileLocation}/${lang}/${fileName}.json`);
      })
    ).pipe(
      map(
        translations => translations.reduce((acc, translation) => ({ ...acc, ...translation })),
        {}
      )
    );
  }
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoRootConfig
    },
    { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader }
  ]
})
export class TranslocoRootModule {}
